// Central brand configuration — single source of truth for Revenue Radar branding.
// To use the official artwork, drop the supplied files into /public/brand/ with the
// filenames below; BrandLogo picks them up automatically and falls back to a styled
// in-brand wordmark until they are present.
export const BRAND = {
  name: "Revenue Radar",
  subtitle: "Business Scanner",
  // The legal / operating entity is intentionally kept separate from the product brand.
  legalEntity: "OpportunityScanner",
  supportEmail: "support@opportunityscanner.com",
  tagline: "Find the revenue and opportunities your business may be missing.",
  // Optional logo assets. If the file exists it is used; otherwise a styled fallback renders.
  heroLogo: "/brand/revenue-radar-illustrated.webp", // Image B — illustrated mascot lockup
  wordmark: "/brand/revenue-radar-wordmark.webp", // Image A — wordmark only
  colors: {
    revenue: ["#F7A41D", "#F97316"], // yellow / orange
    radar: ["#22D3EE", "#2563EB"], // cyan / blue
  },
};

export default BRAND;
